import React from "react";

import { ExclamationCircleOutlined } from "@ant-design/icons";
import { Tooltip } from "antd";

import "./StyledTooltip.css";

const VARIANT_CLASS = {
  dark: "TooltipComponent--dark",
  light: "TooltipComponent--light",
  error: "TooltipComponent--error",
};

export default function StyledTooltip(
  {
    title = "",
    placement = "top",
    showArrow = true,
    children,
    className = "",
    open = null,
    onOpenChange = null,
    getPopupContainer = null,
    autoAdjustOverflow = true,
    variant = "dark",
  },
) {
  const variantClass = VARIANT_CLASS[variant] || VARIANT_CLASS.dark;
  const tooltipTitle = variant === "error" && title
    ? (
      <span className="TooltipComponent__ErrorBody">
        <ExclamationCircleOutlined className="TooltipComponent__ErrorIcon" aria-hidden />
        <span>{title}</span>
      </span>
    )
    : title;

  return (
    <Tooltip
      placement={placement}
      rootClassName={`TooltipComponent ${variantClass} ${className}`.trim()}
      arrow={showArrow !== false}
      title={tooltipTitle}
      open={open}
      onOpenChange={onOpenChange}
      getPopupContainer={getPopupContainer}
      autoAdjustOverflow={autoAdjustOverflow}
    >
      {children}
    </Tooltip>
  );
}
